import React from "react";
import './Referral.css';
import caption from './Resources/leftimage.png';
import right from './Resources/rightimage.png';
import first from './Resources/1year.png';
import second from './Resources/2year.png';
import form from './Resources/form.png';
import { directDeepLink, SOURCE_HOME, SOURCE_WEBVIEW } from "./util"

function Referral(){
    // let path = `https://docs.google.com/forms/d/e/1FAIpQLSdtwyEUno2EXxf2NVsef_T5Yv1nyFcWlr81pBGRQbaYkkrXCA/viewform?vc=0&c=0&w=1&flr=0`; 
   
    return (
      <div className="referral-main">
        <div className="referral-container">
            <div className="referral-sub-container">
                <div className="referral-header">
                        <div className="referral-left">
                            <img src={caption} className="referral-caption"/>
                        </div>
                        <div className="referral-line"></div>
                        <div className="referral-right">
                            <img src={right} className="referral-rimage"/>
                        </div>
                </div>
                <div className="referral-body">
                  <img src={first} className="referral-first"/>
                  <img src={second} className="referral-second"/>
                  <button className="referral-btn" onClick={() => {
                  let DeepLink = {
                    screen: 'UTIL_BROWSER',
                    paramOne: `https://docs.google.com/forms/d/e/1FAIpQLSdtwyEUno2EXxf2NVsef_T5Yv1nyFcWlr81pBGRQbaYkkrXCA/viewform?vc=0&c=0&w=1&flr=0`,
                    // paramOne: `http://shivratriS23-sale.surge.sh/student?token=${token}`,
                    paramTwo: '',
                    // paramTracking: 'StudentSideBannerClickTracking',
                    paramThree: '',
                    paramSource: '',
                  };
                  directDeepLink(DeepLink, SOURCE_HOME);
				}}>
                    <img src={form} className="form-icon"/>
                    Fill form now</button>
                </div>
                
            </div>
        </div>
      </div>
    )
}

export default Referral;